<template>
  <div class="contractors-page">
    <div class="filters">
      <div class="filters__item">
        <CustomSelect :options="this.isNds" :value="filters.is_nds" label="НДС" option-label-key="label"
          option-value-key="value" @change="value => this.onChange('is_nds', value)" />
      </div>

      <div class="filters__item">
        <CustomSelect :options="this.hasSbsCompany" :value="filters.has_sbs_company" label="Заказчик SBS"
          option-label-key="label" option-value-key="value" @change="value => this.onChange('has_sbs_company', value)"
          clearable="true" />
      </div>

      <div class="filters__item">
        <CustomSelect :options="this.hasSbsPartner" :value="filters.has_sbs_partner" label="Подрядчик SBS"
          option-label-key="label" option-value-key="value" @change="value => this.onChange('has_sbs_partner', value)"
          clearable="true" />
      </div>
    </div>

    <CustomTable title="Подрядчики" :rowsData="rowsData" :columns="contractorsColumns" :loading="isFetching"
      :show-search="true" :custom-body="true" :sticky-header="true" :sticky-last-column="true" :showHeaderAdd="true"
      :dense="true" :small="true" :small-font="true" :on-add-click="this.handleAddClick">
      <template #customBody="props">
        <q-tr>
          <custom-table-cell align="center">
            {{ props.row.contractor_id }}
          </custom-table-cell>

          <custom-table-cell align="left">
            <Clickable @click="() => this.handleUpdateClick(props.row)" style="font-size: 13px;">
              {{ props.row.contractor_name }}
            </Clickable>
            <div>
              <q-chip :label="props.row.is_nds ? 'НДС' : 'Без НДС'" outline square style="font-weight: 700;" size="md"
                color="red" />
            </div>
            <div style="display: flex; flex-direction: column; gap: 2px"
              v-if="props.row.sbs_company_id || props.row.sbs_partner_id">
              <div v-if="props.row.sbs_company_id">
                Заказчик SBS:
                <span class="contractors-page__sbs-title">
                  {{
                    props.row.sbs_company_name }}</span>
              </div>
              <div v-if="props.row.sbs_partner_id">
                Подрядчик SBS:
                <span class="contractors-page__sbs-title">
                  {{
                    props.row.sbs_partner_name }}</span>
              </div>
            </div>
            <div class="remarket-logo" @click="() => handleRemarketInfoClick(props.row)">
              <q-tooltip>Посмотреть/изменить информацию в Remarket</q-tooltip>
            </div>
          </custom-table-cell>

          <custom-table-cell align="left" style="min-width: 300px;">
            <div class="providers-page__tax-info">
              <div v-if="props.row.naimenovanie_snr" class="providers-page__tax-item">
                <div class="providers-page__tax-label">
                  <span>СНР</span>
                </div>
                <div class="providers-page__tax-value" v-html="props.row.naimenovanie_snr"></div>
                <div class="providers-page__tax-guid" v-if="props.row.guid_snr_for_onec">
                  GUID: {{ props.row.guid_snr_for_onec }}
                </div>
              </div>
              <div v-if="props.row.naimenovanie_oked" class="providers-page__tax-item">
                <div class="providers-page__tax-label">
                  <span>ОКЭД</span>
                </div>
                <div class="providers-page__tax-value" v-html="props.row.display_name"></div>
                <div class="providers-page__tax-guid" v-if="props.row.guid_oked_for_onec">
                  GUID: {{ props.row.guid_oked_for_onec }}
                </div>
              </div>
            </div>
          </custom-table-cell>

          <custom-table-cell align="left">
            <span v-html="props.row.director_fio"></span>
          </custom-table-cell>

          <custom-table-cell align="left">
            <span v-html="props.row.assign_type_name"></span>
          </custom-table-cell>

          <custom-table-cell align="center" title="Документы">
            <BlockItem>
              <q-btn v-if="props.row.accession_contract_url" label="Скачать документ" color="green" size="sm"
                padding="xs" no-wrap @click="handleClickDoc(props.row.accession_contract_url)" />
              <span v-else>-</span>
            </BlockItem>
          </custom-table-cell>

          <custom-table-cell align="left">
            {{ props.row.legal_name }}
          </custom-table-cell>

          <custom-table-cell align="left">
            <span v-html="props.row.city_name"></span>
          </custom-table-cell>

          <custom-table-cell align="left">
            <div class="info">
              <div class="name">{{ props.row.account_name }}</div>
              <div class="details">
                <div v-if="props.row.iik"><strong>ИИК:</strong> {{ props.row.iik }}</div>
                <div v-if="props.row.bik"><strong>БИК:</strong> {{ props.row.bik }}</div>
                <div v-if="props.row.kbe"><strong>КБЕ:</strong> {{ props.row.kbe }}</div>
                <div v-if="props.row.bin"><strong>БИН:</strong> {{ props.row.bin }}</div>
              </div>
            </div>
          </custom-table-cell>

          <custom-table-cell align="right">
            <span
              v-html="`№${props.row.accession_contract_num} <br/> от <br/> ${props.row.accession_contract_date}`"></span>
          </custom-table-cell>

          <custom-table-cell align="center" style="min-width: 100px;">
            {{ props.row.agreement_postavka_guid }}
          </custom-table-cell>

          <custom-table-cell align="left">
            <div class="info">
              <div class="details">
                <div v-if="props.row.address"><strong>Адрес:</strong> {{ props.row.address }}</div>
                <div v-if="props.row.phone"><strong>Телефон:</strong> {{ props.row.phone }}</div>
                <div v-if="props.row.email"><strong>Email:</strong> {{ props.row.email }}</div>
              </div>
            </div>
          </custom-table-cell>

          <custom-table-cell align="left">
            <span v-if="props.row.is_send_to_1c_text === 'Отправлен в 1С'">
              {{ props.row.is_send_to_1c_text }}
              <br />
              <CheckOrClose :value="props.row.is_send_to_1c" />
            </span>
            <span v-else> {{ props.row.is_send_to_1c_text }} <br /> </span>
            <q-btn v-if="props.row.is_send_to_1c === 0" :loading="btnLoading[props.row.contractor_id]"
              @click="sendTo1CHandler(props.row.contractor_id)" color="primary" size="sm"
              label="Отправить в 1С" dense />
            <span v-if="props.row.guid">
              <br />
              {{ props.row.guid }}
              <q-tooltip>guid</q-tooltip>
            </span>
          </custom-table-cell>

          <custom-table-cell align="center" vertical-align="center">
            <div style="display: flex; align-items: center; justify-content: center; gap: 10px;">
              <CustomIcon @click="() => this.handleUpdateClick(props.row)" icon="edit" />
              <CustomIcon icon="trash" :approve-mode="true" :small="true" :loading="this.loading"
                :approve="() => this.onDeleteSubmit(props.row.contractor_id)" />
            </div>
          </custom-table-cell>
        </q-tr>
      </template>
    </CustomTable>
  </div>
</template>

<script>
import CheckOrClose from "@/components/common/CheckOrClose";
import Clickable from "@/components/common/Clickable";
import CustomDropdown from "@/components/common/CustomDropdown";
import CustomIcon from "@/components/common/CustomIcon";
import CustomTable from "@/components/common/CustomTable";
import CustomTableCell from "@/components/common/CustomTable/custom-table-cell";
import CustomSelect from "@/components/form/CustomSelect";
import { useCustomSnackbar } from "@/_helpers/hooks/useCustomSnackbar";
import { FILE_URL, MODAL_NAMES } from "@/constants";
import { addHandbookContractor, contractorsColumns, deleteHandbookContractor, getHandbookContractors, sendTo1C, updateHandbookContractor } from "@/views/Contractors/services";
import { useAppStore } from "@/services/store/app";

export default {
  name: "HandbookContractors",
  components: { CustomSelect, CustomTable, CustomTableCell, CustomIcon, CustomDropdown, Clickable, CheckOrClose },
  data() {
    return {
      contractorsColumns,
      rowsData: [],
      isFetching: false,
      isModalOpen: false,
      isEditMode: false,
      currentContractor: null,
      btnLoading: {},
      filters: {
        is_nds: null,
        has_sbs_company: null,
        has_sbs_partner: null,
      },
      hasSbsCompany: [
        { label: 'Все', value: null },
        { label: 'Привязан', value: true },
        { label: 'Не привязан', value: false },
      ],
      hasSbsPartner: [
        { label: 'Все', value: null },
        { label: 'Привязан', value: true },
        { label: 'Не привязан', value: false },
      ],
      isNds: [
        { label: 'Все', value: null },
        { label: 'НДС', value: true },
        { label: 'Без НДС', value: false },
      ],
    };
  },
  methods: {
    async getData() {
      this.isFetching = true;
      const res = await getHandbookContractors(this.filters);
      this.isFetching = false;
      if (res) {
        this.rowsData = res;
      }
    },
    async handleAddClick() {
      this.showModal(MODAL_NAMES.Add_HANDBOOK_CONTRACTOR, {
        onSubmit: this.onAddSubmit,
        title: 'Добавить подрядчика'
      });
    },
    async handleUpdateClick(row) {
      this.showModal(MODAL_NAMES.Add_HANDBOOK_CONTRACTOR, {
        onSubmit: (body) => this.onUpdateSubmit(row.contractor_id, body),
        title: 'Изменить подрядчика',
        body: row
      });
    },
    async onAddSubmit(body) {
      const res = await addHandbookContractor(body)
      if (!res) return
      this.rowsData = res
      this.showSucceedSnackbar()
      this.closeModal();
    },
    async onUpdateSubmit(contractor_id, body) {
      const res = await updateHandbookContractor(contractor_id, body)
      if (!res) return
      this.rowsData = res
      this.showSucceedSnackbar()
      this.closeModal();
    },
    async onDeleteSubmit(contractor_id) {
      this.loading = true
      const res = await deleteHandbookContractor(contractor_id)
      this.loading = false
      if (!res) return
      this.rowsData = res
      this.showSucceedSnackbar()
      this.closeModal();
    },
    handleClickDoc(link) {
      const url = `${FILE_URL}/${link}`
      window.open(url, "_blank")
    },
    async sendTo1CHandler(contractor_id) {
      this.btnLoading = { ...this.btnLoading, [contractor_id]: true };
      const response = await sendTo1C(contractor_id);
      this.btnLoading = { ...this.btnLoading, [contractor_id]: false };
      if (!response) return;
      const message = response.message || response.description || "Успешно отправлено в 1С";
      this.showSucceedSnackbar(message);
      await this.getData();
    },
    
    handleRemarketInfoClick(row) {
      this.$router.push({
        name: 'remarketContractorInfo',
        query: { contractorId: row.contractor_id }
      });
    },
    onChange(key, value) {
      this.filters[key] = value;
      this.$router.push({
        query: { ...this.$route.query, [key]: value || undefined },
      });
      this.getData()
    },
    initializeFiltersFromURL() {
      const query = this.$route.query;
      if (query) {
        Object.keys(this.filters).forEach((key) => {
          if (query[key] !== undefined && query[key] !== null) {
            let value = query[key];

            if (value === 'true') {
              value = true;
            } else if (value === 'false') {
              value = false;
            } else if (value === 'null' || value === '') {
              value = null;
            }

            this.filters[key] = value;
          }
        });
      }
    },
  },
  created() {
    this.initializeFiltersFromURL();
  },
  mounted() {
    this.getData();
  },
  setup() {
    const { showSucceedSnackbar } = useCustomSnackbar();
    const { showModal, closeModal } = useAppStore();
    return { showSucceedSnackbar, showModal, closeModal };
  },
};
</script>

<style scoped>
.remarket-logo {
  margin-top: 10px;
  width: 20px;
  height: 20px;
  background: url('@/assets/img/remarket-only-logo.svg') no-repeat center;
  background-size: contain;
  transition: transform 0.3s ease;
}

.remarket-logo:hover {
  cursor: pointer;
  transform: scale(1.1);
}

.contractors-page__sbs-title {
  font-size: 12px;
  color: #ff9800;
}

.filters {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
  padding: 10px;

  &__item {
    width: 150px;

    &_select {
      width: 200px;
    }
  }
}

.info {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 8px 10px;
  font-size: 12px;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  border-radius: 6px;
  border: 1px solid #e9ecef;
  transition: all 0.2s ease;
}

.info:hover {
  border-color: #d4d9df;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.name {
  font-weight: 600;
  font-size: 13px;
  color: #1976d2;
  margin-bottom: 2px;
  padding-bottom: 4px;
  border-bottom: 1px solid #e9ecef;
}

.details {
  display: flex;
  flex-direction: column;
  gap: 4px;
  color: #495057;
  line-height: 1.5;
}

.details>div {
  display: flex;
  align-items: baseline;
  gap: 4px;
}

.details strong {
  color: #6c757d;
  font-weight: 600;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  min-width: 65px;
}

.providers-page__tax-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.providers-page__tax-item {
  padding: 8px;
  background: #f8f9fa;
  border-radius: 6px;
  border-left: 3px solid #1976d2;
  transition: all 0.2s ease;
}

.providers-page__tax-item:hover {
  background: #e9ecef;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.providers-page__tax-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 600;
  color: #495057;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
}

.providers-page__tax-icon {
  color: #1976d2;
}

.providers-page__tax-value {
  font-size: 13px;
  font-weight: 500;
  color: #212529;
  line-height: 1.4;
  margin-bottom: 4px;
}

.providers-page__tax-guid {
  font-size: 10px;
  color: #6c757d;
  font-family: 'Courier New', monospace;
  background: white;
  padding: 2px 6px;
  border-radius: 3px;
  display: inline-block;
  margin-top: 2px;
}
</style>